import React from 'react'

const AddAditional = ({ id }) => {
    return (
        <div
            className="modal fade"
            id={id}
            tabIndex={-1}
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
        >
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">
                            Add Aditionals
                        </h5>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        />
                    </div>
                    <div className="modal-body"><form>
                        <div className="mb-3">
                            <label htmlFor="exampleInputEmail1" className="form-label">
                                Add Aditional
                            </label>
                            <input
                                type="text"
                                className="form-control form-control-sm"
                            />

                        </div>
                        <div className="text-right">
                            <button type="button" className="btn btn-primary" data-bs-dismiss="modal">
                                Add
                            </button>
                        </div>
                    </form>
                    </div>
                    {/* <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-light"
                            data-bs-dismiss="modal"
                        >
                            Close
                        </button>
                        <button type="button" className="btn btn-primary">
                            Add
                        </button>
                    </div> */}
                </div>
            </div>
        </div>

    )
}

export default AddAditional